import axiosInstance, { axiosInstanceCached } from '@/utils/axios';
import { handleApiError, deleteDataCache } from '@/utils/helpers';

// @ Sample cache test logging
// console.log('activeUsers response:', response);
// console.log('activeUsers cached:', response.cached);
// console.log('activeUsers ttl:', response.config?.cache?.ttl);
// console.log('activeUsers config:', response.config);
// console.log('activeUsers duration:', response.duration);
// console.log('============================');

//* Admin - GET Partner by token
export const partner = async () => {
  let response = {};

  try {
    response = await axiosInstance.get(`/partners`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* Admin - GET Partner Products
export const partnerProducts = async () => {
  let response = {};

  try {
    response = await axiosInstance.get(`/partners/products`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* Admin - Create Partner Product Key
export const createPartnerProductKeys = async (payload) => {
  let response = {};

  try {
    response = await axiosInstance.post(`/partners/productkeys`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* Admin - GET Partner Product Keys
export const partnerProductKeys = async ({
  limit = '',
  offset = '',
  batchID = '',
  createdByID = '',
  productKey = '',
  skucode = '',
  skucodes = '',
  userID = '',
  type = '',
  partnerID = '',
  desktopLicenseID = '',
  mobileLicenseID = '',
  redeemedFromDate = '',
  redeemedToDate = '',
  createdFromDate = '',
  createdToDate = '',
}) => {
  let response = {};
  let url = `/partners/productkeys?limit=${limit}&offset=${offset}`;

  // @ FILTER SETUP ===========================================
  //* Batch UUID filter
  if (batchID) {
    url = `${url}&batch_uuid=${batchID}`;
  }
  //* Created By ID filter
  if (createdByID) {
    url = `${url}&created_by_user_id=${createdByID}`;
  }
  //* Product Key filter
  if (productKey) {
    url = `${url}&product_key=${productKey}`;
  }
  //* User ID filter
  if (userID) {
    url = `${url}&user_id=${userID}`;
  }
  //* Sku code(s) filter
  if (skucode) {
    url = `${url}&skucode=${skucode}`;
  }
  if (skucodes) {
    skucodes.forEach((sku) => {
      url = `${url}&skucodes=${sku}`;
    });
  }
  //* Key Type
  if (type) {
    url = `${url}&type=${type}`;
  }
  //* Partner ID
  if (partnerID) {
    url = `${url}&partner_id=${partnerID}`;
  }
  //* Desktop License ID filter
  if (desktopLicenseID) {
    url = `${url}&desktop_license_id=${desktopLicenseID}`;
  }
  //* Mobile License ID filter
  if (mobileLicenseID) {
    url = `${url}&mobile_license_id=${mobileLicenseID}`;
  }
  //* Updated At/Redeemed At from and to dates
  if (redeemedFromDate) {
    url = `${url}&updated_at_gteq=${redeemedFromDate}`;
  }
  if (redeemedToDate) {
    url = `${url}&updated_at_lteq=${redeemedToDate}`;
  }
  //* Created At from and to dates
  if (createdFromDate) {
    url = `${url}&created_at_gteq=${createdFromDate}`;
  }
  if (createdToDate) {
    url = `${url}&created_at_lteq=${createdToDate}`;
  }

  try {
    response = await axiosInstance.get(url);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* Partner - GET Partner Product Key Report
export const partnerKeyReport = async ({ fromDate, toDate }) => {
  let response = {};
  const url = `/partners/productkeys/report?fromDate=${fromDate}&toDate=${toDate}`;

  try {
    response = await axiosInstance.get(url);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};
